import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TabItem } from '../../models/formly-custom';

@Component({
  selector: 'app-tab-group',
  imports: [],
  templateUrl: './tab-group.component.html',
  styleUrl: './tab-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabGroupComponent {
  activeTabId: number = 0;

  @Input() tabList: TabItem[] = [];
  @Input() readonly: boolean = false;

  @Input() set activeItem(item: any) {
    this.activeTabId = item?.id; //unique tab no
  }

  @Output() tabChanged: EventEmitter<any> = new EventEmitter();
  @Output() tabRemoved: EventEmitter<any> = new EventEmitter();

  constructor() {}

  setActiveTab(tab: any) {
    if (tab.id != this.activeTabId) {
      this.activeTabId = tab.id;
      this.tabChanged.emit(tab);
    }
  }

  removeTab(index: number, tab: TabItem) {
    if (index > -1) {
      this.tabList.splice(index, 1);
      this.tabRemoved.emit({ index: index, data: tab });
    }
  }
}
